import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "gradient", "less", "more"]
  static values = { collapsedHeight: { type: Number, default: 250 } }

  connect() {
    this.expanded = false
    this.refresh()
    this.element.dataset.productDescriptionReady = "true"
  }

  disconnect() {
    delete this.element.dataset.productDescriptionReady
  }

  expand() {
    this.expanded = true
    this.gradientTarget.hidden = true
    this.moreTarget.hidden = true
    this.lessTarget.hidden = false
    this.contentTarget.style.height = `${this.contentTarget.scrollHeight}px`
    this.contentTarget.dataset.expanded = "true"
  }

  collapse() {
    this.expanded = false
    this.gradientTarget.hidden = false
    this.moreTarget.hidden = false
    this.lessTarget.hidden = true
    this.contentTarget.style.height = `${this.collapsedHeightValue}px`
    this.contentTarget.dataset.expanded = "false"
  }

  refresh() {
    if (this.expanded) {
      this.contentTarget.style.height = "auto"
      this.contentTarget.style.height = `${this.contentTarget.scrollHeight}px`
      return
    }

    this.contentTarget.style.height = `${this.collapsedHeightValue}px`
    const overflowing = this.contentTarget.scrollHeight > this.collapsedHeightValue
    this.gradientTarget.hidden = !overflowing
    this.moreTarget.hidden = !overflowing
    this.lessTarget.hidden = true
    if (!overflowing) this.contentTarget.style.height = "auto"
  }
}
